export default __webpack_public_path__ + "static/media/platinum@2x.f399aaca.png";